module.exports = __webpack_public_path__ + "img/templates-available.b9f13de6.png";